import Styled from './SourceKeys.styled';

export interface SourceKeysProps {
  labels: readonly string[];
  colors: readonly string[];
  title?: string;
}

function SourceKeys({ labels, colors, title = 'Key:' }: SourceKeysProps) {
  return (
    <Styled.Wrapper>
      <Styled.KeyLabel>{title}</Styled.KeyLabel>
      {labels.map((label, index) => (
        <Styled.Item key={`${label}-${index}`}>
          <Styled.ItemDot color={colors[index]} />
          <Styled.ItemLabel>{label}</Styled.ItemLabel>
        </Styled.Item>
      ))}
    </Styled.Wrapper>
  );
}

export default SourceKeys;
